// Drag-to-scroll: attach to any horizontal scrollable div via ref callback
export function dragScrollRef(el) {
    if (!el || el._dragScroll) return;
    el._dragScroll = true;
    let isDown = false, startX = 0, sl = 0, dragged = false;
    el.style.cursor = 'grab';
    el.onmousedown = (e) => {
        // Only left click
        if (e.button !== 0) return;
        isDown = true; dragged = false;
        startX = e.pageX; sl = el.scrollLeft;
        el.style.cursor = 'grabbing'; el.style.userSelect = 'none';
    };
    el.onmousemove = (e) => {
        if (!isDown) return;
        const dx = Math.abs(e.pageX - startX);
        if (dx > 5) dragged = true;
        if (dragged) { e.preventDefault(); el.scrollLeft = sl - (e.pageX - startX); }
    };
    el.onmouseup = () => { isDown = false; el.style.cursor = 'grab'; el.style.userSelect = ''; };
    el.onmouseleave = () => { isDown = false; el.style.cursor = 'grab'; el.style.userSelect = ''; dragged = false; };
    // Block button clicks only when actually dragged
    el.addEventListener('click', (e) => {
        if (dragged) { e.stopPropagation(); e.preventDefault(); dragged = false; }
    }, true);
}

// Desktop height: controlled by desktop_height config (vh slider), default 70vh
// Mobile height: fixed min-h on mobile, auto-height mode removes it
export const DESKTOP_HEIGHTS_VH = { '30vh': 'sm:min-h-[30vh]', '35vh': 'sm:min-h-[35vh]', '40vh': 'sm:min-h-[40vh]', '45vh': 'sm:min-h-[45vh]', '50vh': 'sm:min-h-[50vh]', '55vh': 'sm:min-h-[55vh]', '60vh': 'sm:min-h-[60vh]', '65vh': 'sm:min-h-[65vh]', '70vh': 'sm:min-h-[70vh]', '75vh': 'sm:min-h-[75vh]', '80vh': 'sm:min-h-[80vh]', '85vh': 'sm:min-h-[85vh]', '90vh': 'sm:min-h-[90vh]', '95vh': 'sm:min-h-[95vh]', '100vh': 'sm:min-h-[100vh]' };
